import I from '../types.ts';

const checkPage: I['checkPage'] = function () {
    const { levels, sections } = this.props;

    if (levels[1] === 'blog') {
        this.section = levels[2] || 'all';

        if (
            this.section !== this.state.currentSection &&
            (sections.includes(this.section) || this.section === 'all')
        ) {
            this.setState({ currentSection: this.section }, () => {
                if (!this.isInit) {
                    this.isInit = true;

                    this.getItems!({});
                } else {
                    this.updateItems();
                }
            });
        }
    }
};

export default checkPage;
